import { inject, Injectable } from '@angular/core';
import {
    DirectoryTypeModalComponent
} from '@athlete-x/ui/sidebar/components/directory-type-modal/directory-type-modal.component';
import { ModalController } from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class GlobalService {
    private _modalCtrl = inject(ModalController);

    public openChangeAccessModal() {
        return this._modalCtrl
            .create({
                component: DirectoryTypeModalComponent,
                cssClass: 'directory-type-modal'
            })
            .then(modal => {
                modal.present();
                return modal.onDidDismiss();
            })
            .then(({ data, role }) => {
                if (role === 'confirm') {
                    const { global } = data;
                    return global;
                }
            });
    }
}
